import { Buttons } from "components";
import { BoxConfirmActionStyled } from "./styled";

const BoxConfirmAction = ({
  handleConfirm,
  handleCancel,
  textShow = "ยืนยัน",
  textBottom,
  labelCancel = "ยกเลิก",
  labelConfirm = "ยืนยัน",
}) => {
  return (
    <BoxConfirmActionStyled>
      <div className="title_text">{textShow}</div>
      {textBottom && <div className="sub_text">{textBottom}</div>}
      <div className="action_row">
        <div className="btn_wrap">
          <Buttons.BtnNormal
            theme_only_border_blue
            label={labelCancel}
            fontSize="18px"
            paddingButton="9px"
            borderRadius="10px"
            backgroundColor="#fff"
            onClick={handleCancel}
          />
        </div>
        <div className="btn_wrap">
          <Buttons.BtnNormal
            theme_only_border_blue
            label={labelConfirm}
            fontSize="18px"
            paddingButton="9px"
            borderRadius="10px"
            onClick={handleConfirm}
          />
        </div>
      </div>
    </BoxConfirmActionStyled>
  );
};

export default BoxConfirmAction;
